import { createSelector } from 'reselect';
import { IUser } from '.';
import { IState } from '..';

export const getUser = createSelector(
  [(state: IState) => state.users.hash, (_: IState, sid: string) => sid],
  (userHash, sid): IUser | undefined => userHash[sid]
);

export const getUserName = createSelector(getUser, user => (user ? user.name : ''));
